import { qantProductAdmin } from '../condition.js';
import type { ProductMenuDef } from '../type.js';

/**
 * GlobalNaviV2 で表示する Knowledge Desk（オペレーター向け）のメニュー定義。
 */
export const QANT_DESK_MENU = {
  product: {
    name: 'desk',
    icon: 'qantKnowledgeDesk',
    label: { ja: 'ナレッジデスク', en: 'Knowledge Desk' },
    description: { ja: 'オペレーター向けナレッジツール', en: 'Knowledge Desk' },
  },
  menuGroups: {
    OPERATOR: {
      name: 'operator',
      label: { ja: 'オペレーター', en: 'Operator' },
      menus: {
        RESPONSE_BOARD: {
          name: 'responseBoard',
          icon: 'knowledgeDeskResponseBoard',
          label: { ja: '応対ボード', en: 'Response Board' },
          path: { host: 'qant', path: '/desk/item' },
        },
        AFTER_CALL_WORK: {
          name: 'afterCallWork',
          icon: 'knowledgeDeskAfterCallWork',
          label: { ja: 'アフターコールワーク', en: 'After Call Work' },
          path: { host: 'qant', path: '/desk/afterCallWork' },
        },
      },
    },
    ADMIN: {
      name: 'admin',
      label: { ja: '管理', en: 'Admin' },
      menus: {
        HUB_LIBRARY: {
          name: 'hubLibrary',
          icon: 'knowledgeDeskLibrary',
          label: { ja: 'ライブラリ', en: 'Library' },
          path: { host: 'qant', path: '/knowledge/' },
          options: { openAnotherTab: true },
          condition: qantProductAdmin('desk'),
        },
        REPORT: {
          name: 'report',
          icon: 'knowledgeDeskReport',
          label: { ja: 'レポート', en: 'Report' },
          path: { host: 'qant', path: '/desk/report/search-word' },
          condition: qantProductAdmin('desk'),
        },
        SETTINGS: {
          name: 'settings',
          icon: 'settings',
          label: { ja: '設定', en: 'Settings' },
          path: { host: 'qant', path: '/desk/settings' },
          condition: qantProductAdmin('desk'),
        },
      },
    },
  },
} as const satisfies ProductMenuDef;
